import { render } from "./PopUp.vue?vue&type=template&id=c0fc7274&scoped=true"
import script from "./PopUp.vue?vue&type=script&lang=js"
export * from "./PopUp.vue?vue&type=script&lang=js"

import "./PopUp.vue?vue&type=style&index=0&id=c0fc7274&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0fc7274"]])

export default __exports__